import React from 'react';
import {Modal, Spinner} from "react-bootstrap";

const style = {
  display: 'flex',
  justifyContent: 'center',
  align: 'center',
};

const Loading = ({title}) =>
<div className="Loading">
  <Modal
      show={true}
      align={"center"}
      valign={"center"}
      backdrop="static"
      keyboard={false}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
  >
      <Modal.Body>
        <div className="Loading" >
          <div>{title ? <h3>{title}</h3>:<h3>Laddar...</h3>}</div>
          <div style={style}><Spinner animation="border" role="status" /></div>
        </div>
      </Modal.Body>
    </Modal>
</div>

export default Loading